import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css";
import axios from 'axios';
import { List_Checker, checkerassignedtemplates, assign_template, ListAlldept, list_deptwisetemplates } from "../components/ApiProperty";
import { UsersPagination } from "../components/TableProperty";
import { Button, Modal } from 'react-bootstrap';
import { LoadingIcon } from "../components/Propertyfile";
import { PaginationComponentForm2 } from "../components/TableProperty";
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import { useNavigate } from 'react-router-dom';
import '../assets/css/Tableproperty.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';

const GapsySamplePage = () => {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCheckerName, setSelectedCheckerName] = useState('');
    const recordsPerPage = 16;
    const [templates, setTemplates] = useState([]);
    const [isLoadingUserTable, setIsLoadingUserTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [templateAssignments, setTemplateAssignments] = useState({});
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [userPage, setUserPage] = useState(1);
    const [userItemsPerPage] = useState(5);
    const [unsavedChanges, setUnsavedChanges] = useState(false); // Track unsaved changes
    const [successMsg, setSuccessMsg] = useState(false);
    const [failureMsg, setFailureMsg] = useState(false);
    const [warningMsg, setWarningMsg] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState('');
    const [onConfirmAction, setOnConfirmAction] = useState(null); // Store the confirm callback
    const [notificationType, setNotificationType] = useState('IN');
    const [showNotifyPriorityModal, setShowNotifyPriorityModal] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [departments, setDepartments] = useState("");

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentTemplates = templates.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(templates.length / recordsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const userId = localStorage.getItem("userid");
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const userDept = localStorage.getItem("dept");
    useEffect(() => {
        const fetchDepartments = async () => {
            if (userDept === 'IT') {
                try {
                    const deptConfig = {
                        headers: {
                            'x-csrf-token': csrfToken,
                        },
                        withCredentials: true
                    };
                    const response = await axios.post(ListAlldept, {}, deptConfig);
                    const deptList = response.data?.department || [];

                    const formatted = deptList.map((name, index) => ({
                        id: index + 1,
                        name,
                    }));

                    setDepartments(formatted);
                } catch (error) {
                    console.error('Error fetching departments:', error);
                    setDepartments([]);
                }
            } else {
                // Only user’s department
                setDepartments([{ id: 1, name: userDept }]);
                setSelectedDepartment(userDept); // Auto select for non-IT users
            }
        };

        fetchDepartments();
    }, [userDept]);

    // 2. Fetch templates based on selected department
    useEffect(() => {
        const fetchTemplatesList = async () => {
            if (!selectedDepartment) return;

            try {
                const config = {
                    params: {
                        adminId: userId,
                        dept: selectedDepartment
                    },
                    headers: { "x-csrf-token": csrfToken },
                    withCredentials: true,
                };
                const response = await axios.post(list_deptwisetemplates, {}, config);
                const allTemplates = response.data?.tables || [];

                // Filter templates by selected department prefix
                const filtered = allTemplates
                    .filter(template => template.startsWith(`${selectedDepartment}_`))
                    .map((template, index) => ({
                        id: index + 1,
                        name: template.replace(`${selectedDepartment}_`, '') // Remove dept prefix
                    }));

                setTemplates(filtered);
            } catch (error) {
                console.error('Error fetching templates:', error);
                setTemplates([]);
            }
        };

        fetchTemplatesList();
    }, [selectedDepartment]);


    useEffect(() => {
        const fetchTemplatesCheckers = async () => {
            try {
                const config = {
                    params: { "adminId": localStorage.getItem('userid'), "dept": selectedDepartment },
                    headers: { "x-csrf-token": csrfToken },
                    withCredentials: true,
                };
                const responseChecker = await axios.post(List_Checker, {}, config);
                if (responseChecker.data?.status === "success" && Array.isArray(responseChecker.data.checkers_list)) {
                    setUsers(responseChecker.data.checkers_list.map(user => ({
                        id: user.userId,
                        name: user.userName
                    })));
                } else {
                    console.error('Unexpected checkers data structure:', responseChecker.data);
                    setUsers([]);
                }

            } catch (error) {
                console.error('Error fetching users and templates:', error);
                setUsers([]);
                setTemplates([]);
            }
        };

        fetchTemplatesCheckers();
    }, [selectedDepartment]);


    // Function to show the confirm modal with a dynamic message and action callback
    const handleShowConfirm = (message, onConfirm) => {
        setConfirmMessage(message);   // Set the dynamic message
        setOnConfirmAction(() => onConfirm); // Set the action callback
        setShowConfirm(true);  // Show the modal
    };

    // Function to close the modal
    const handleCloseConfirm = () => {
        setShowConfirm(false);
    };

    // Function to handle confirmation and run the action
    const handleConfirmAction = async () => {
        if (onConfirmAction) {
            await onConfirmAction(); // Run the passed-in action
        }
        setShowConfirm(false);
    };

    const handleSelectChange = async (e) => {
        const selectedCheckerId = e.target.value;

        const selectedUser = users.find(user => user.id.toString() === selectedCheckerId);
        if (selectedUser) {
            setSelectedCheckerName(selectedUser.name);
        }

        const fetchAssignedTemplates = async (checkerId) => {
            setSelectedOption(checkerId);
            setTableData([]);
            setTemplateAssignments({});
            setUnsavedChanges(false);
            setUserPage(1);
            if (checkerId) {
                try {
                    const config = {
                        params: {
                            "adminId": localStorage.getItem('userid'),
                            "userId": checkerId
                        },
                        headers: { "x-csrf-token": csrfToken },
                        withCredentials: true,
                    };

                    const response = await axios.post(checkerassignedtemplates, {}, config);

                    if (response.data && Array.isArray(response.data.templates)) {
                        const updatedTableData = response.data.templates.map((assignment) => {
                            // const checker = users.find(user => user.id === parseInt(checkerId));
                            const checker = users.find(user => String(user.id) === String(checkerId));
                            const tableNameParts = assignment.Table_name.split('_');
                            const cleanedTableName = tableNameParts.slice(1).join('_');

                            return {
                                checkerId: checkerId,
                                checkerName: checker?.name || '',
                                selectedTemplate: cleanedTableName,
                            };
                        });

                        setTableData(updatedTableData);
                        setUserPage(1);
                    } else {
                        console.error('API response does not contain the expected structure');
                        setTableData([]);
                    }
                } catch (error) {
                    console.error('Error fetching template assignments:', error);
                    setTableData([]);
                }
            }
        };

        if (unsavedChanges) {
            handleShowConfirm("You have unsaved changes. Do you want to continue without Saving?", () => {
                fetchAssignedTemplates(selectedCheckerId);
                setUserPage(1);
            });
            return;
        }

        fetchAssignedTemplates(selectedCheckerId);
    };


    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    const handleReset = () => {
        setSelectedOption('');
        setTableData([]);
        setTemplateAssignments({});
        setSuccessMsg('');
        setFailureMsg('');
        setWarningMsg('');
    };

    const handleSet = () => {
        setSuccessMsg('');
        setFailureMsg('');
        setWarningMsg('');
    };

    const handleCheckboxChange = (templateName) => {
        setUnsavedChanges(true);

        const isAssignedToCurrent = templateAssignments[templateName] === selectedOption;
        const anyAssigned = Object.keys(templateAssignments).length > 0;

        if (isAssignedToCurrent) {
            // Uncheck: remove assignment and update tableData accordingly
            setTemplateAssignments((prev) => {
                const updated = { ...prev };
                delete updated[templateName];
                return updated;
            });

            setTableData((prevData) =>
                prevData.filter(row => row.selectedTemplate !== templateName)
            );

            return;
        }

        if (anyAssigned) {
            // Only one template allowed at a time
            setWarningMsg("Assignment limited to one Template at a time");
            setTimeout(() => setWarningMsg(false), 4000);
            return;
        }

        // Check if template already assigned in tableData
        const existingRow = tableData.some(row => row.selectedTemplate === templateName);
        if (existingRow) {
            setWarningMsg(`<strong>${toTitleCase(templateName)}</strong> Template is already assigned to <strong>${selectedCheckerName}</strong>`);
            setTimeout(() => setWarningMsg(false), 4000);
            return;
        }

        // Assign the selected template
        setTemplateAssignments((prev) => {
            const updated = {
                ...prev,
                [templateName]: selectedOption,
            };

            // const checker = users.find(user => user.id === parseInt(selectedOption, 10));
            const checker = users.find(user => String(user.id) === String(selectedOption));

            setTableData((prevData) => [
                ...prevData,
                {
                    checkerId: selectedOption,
                    checkerName: checker?.name || '',
                    selectedTemplate: templateName,
                },
            ]);

            return updated;
        });
    };

    const handleSave = () => {
        handleNotifyPriority();
    };

    const showSuccessMessage = (message) => {
        setSuccessMsg(false);
        setFailureMsg(false);
        setWarningMsg(false);

        setTimeout(() => {
            setSuccessMsg(message);
        }, 0);
    };


    const handleNotifyPriority = async () => {
        setUnsavedChanges(false);
        const adminId = localStorage.getItem('userid');

        const detail = Object.keys(templateAssignments).map((templateName) => ({
            mappedid: parseInt(templateAssignments[templateName], 10),
            template: templateName
        }));

        const payload = {
            adminId,
            detail
        };

        let config = {
            params: { type: "regular", "Notifications": notificationType, "dept": selectedDepartment },
            headers: { "x-csrf-token": csrfToken },
            withCredentials: true,
        };

        setIsLoading(true);
        try {
            // Initial API call
            const response = await axios.post(assign_template, payload, config);
            if (response.data.status === "success") {
                const message = response.data.message;

                let newTemplateName = "Template";

                const match = message.match(/for template "(.*?)"/);
                if (match && match[1]) {
                    const templateName = match[1];
                    const parts = templateName.split('_');

                    if (parts.length > 1) {
                        parts.shift(); // remove prefix
                        const firstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
                        const remaining = parts.slice(1).join('_');
                        newTemplateName = firstPart + (remaining ? `_${remaining}` : '');
                    }
                }

                const finalMessage = `<strong>${toTitleCase(newTemplateName)}</strong> Template Assigned Successfully to the Checker <strong>${selectedCheckerName}</strong>`;

                showSuccessMessage(finalMessage); //  ensures modal shows
                setWarningMsg(false);
                setFailureMsg(false);
            }

            if (response.data.alert && response.data.alert === "Template_exists_already") {
                const warningText = response.data.message;

                const templateMatch = warningText.match(/"(.+?)"/);
                let rawTemplateName = templateMatch?.[1] || "Unknown_Template";

                // Format the template name
                const parts = rawTemplateName.split('_');
                if (parts.length > 1) parts.shift(); // remove prefix
                const formattedTemplateName = toTitleCase(parts.join(' ').replace(/_/g, ' '));

                const checkerIdNameMap = {
                    10063: 'Mouli',
                    10007: 'Rajini',
                    10118: 'Prema',
                };

                const checkerIdMatch = warningText.match(/template_checker\(s\):\s*([0-9,\s]+)/i);
                const assignedCheckerIds = checkerIdMatch?.[1]?.trim().split(/\s*,\s*/) || ["Unknown"];

                // Map each ID to a name using the checkerIdNameMap
                const assignedCheckerNames = assignedCheckerIds
                    .map(id => checkerIdNameMap[id] || `ID ${id}`)
                    .join(', ');

                // Updated confirmation message using checker names instead of selectedCheckerName
                const formattedConfirmMessage = `<strong>${toTitleCase(formattedTemplateName)} Template</strong> is already assigned to <strong>${assignedCheckerNames}</strong>. Do you wish to Re&#8209;assign to a different Checker?`;

                // Now call with custom message
                handleShowConfirm(formattedConfirmMessage, async () => {
                    try {
                        const config = {
                            params: { type: "direct", Notifications: notificationType, dept: selectedDepartment },
                            headers: { "x-csrf-token": csrfToken },
                            withCredentials: true,
                        };

                        const retryResponse = await axios.post(assign_template, payload, config);
                        // continue your retry logic...

                        if (retryResponse.data.status === "success") {
                            // const modifiedRetryMessage = transformTemplateNameInMessage(retryResponse.data.message);
                            const originalMessage = retryResponse.data.message;

                            const modifiedMessage = originalMessage.replace(
                                /for template "(.*?)"/,
                                (match, templateName) => {
                                    const parts = templateName.split('_');
                                    let newTemplateName = templateName;

                                    if (parts.length > 1) {
                                        parts.shift(); // Remove prefix
                                        const firstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
                                        const remaining = parts.slice(1).join('_');
                                        newTemplateName = firstPart + (remaining ? `_${remaining}` : '');
                                    }

                                    const finalMessage = `<strong>${toTitleCase(newTemplateName)}</strong> Template Re-assigned Successfully to the Checker <strong>${selectedCheckerName}</strong>`;
                                    return finalMessage;
                                }
                            );

                            setSuccessMsg(modifiedMessage);
                            // setSuccessMsg(modifiedRetryMessage);
                            setFailureMsg(false);
                            setWarningMsg(false);

                        } else if (retryResponse.data.status === "warning") {
                            const backendMessage = retryResponse.data.message;

                            // Extract template name from backend message (fallback: Unknown Template)
                            const match = backendMessage.match(/"(.+?)"/);
                            let rawTemplateName = match?.[1] || "Unknown_Template";

                            // Format template name: remove prefix, convert to title case
                            const parts = rawTemplateName.split('_');
                            if (parts.length > 1) parts.shift(); // remove prefix
                            const cleanedTemplateName = toTitleCase(parts.join(' ').replace(/_/g, ' '));

                            // Use selectedCheckerName to build the custom message
                            const modifiedWarningMessage = `<strong>${cleanedTemplateName} Template</strong> is assigned to <strong>${selectedCheckerName}</strong>. Do you wish to Re&#8209;assign to a different Checker?`;

                            // Now actually override the warningMsg state
                            setWarningMsg(modifiedWarningMessage);
                            setSuccessMsg(false);
                            setFailureMsg(false);
                            setShowNotifyPriorityModal(false);
                        }

                        else {
                            setFailureMsg(retryResponse.data.message || "Error occurred on retry");
                            setSuccessMsg(false);
                            setWarningMsg(false);
                            setShowNotifyPriorityModal(false);
                        }

                    } catch (retryError) {
                        console.error('Error saving data on retry:', retryError);
                        setFailureMsg("Error saving data on retry", retryError);
                        setTimeout(() => setFailureMsg(false), 2000);
                    }
                });

                return; // Stop further execution until confirmation
            }


        } catch (error) {
            console.error('Error saving data:', error);
            setFailureMsg("Error saving data", error);
            setSuccessMsg(false);
            setWarningMsg(false);
            // setTimeout(() => setFailureMsg(false), 2000);
        } finally {
            setIsLoading(false); // Set loading to false after fetching data
        }
    };

    const handleDashboard = () => {
        navigate('/gapsyAdashboard');
    };

    const renderUserTable = () => {
        if (isLoading) {
            return (
                <tr>
                    <td colSpan="3" className="text-center py-3">
                        <span className="spinner-border spinner-border-sm text-primary" />
                    </td>
                </tr>
            );
        }

        const startIndex = (userPage - 1) * userItemsPerPage;
        const paginatedTableData = tableData.slice(startIndex, startIndex + userItemsPerPage);

        return paginatedTableData.map((data, index) => (
            <tr key={index}>
                <td>{data.checkerId || 'None'}</td>
                <td>{data.checkerName || 'None'}</td>
                <td>{data.selectedTemplate || 'None'}</td>
            </tr>
        ));
    };



    const handleDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <ol className="breadcrumb mb-1">
                                    <li className="breadcrumb-item">
                                        <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{textDecoration: 'none' }}>
                                            <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                        </a>
                                    </li>

                                    <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                        <i className="bi bi-shuffle me-2"></i>Re-Assign Template
                                    </li>
                                </ol>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className="container-fluid">
                    <div className={`${styles.containerRow} row`}>
                        <div className="position-relative">
                            <h6 className={`pb-1 mb-1 ${styles.borderBottom}`}>Template Assignment</h6>
                        </div>
                        <div className={`col-md-3 col-sm-4 ${styles.supportedFileFormats}`}>
                            <div className="mb-2">
                                <h6 className="mb-1 mt-1 text-dark">Required Info</h6>
                            </div>
                            <div className="table-on-homepage-only">
                                <div className="mb-2">

                                    <label htmlFor="department" className="form-label text-black mb-1">
                                        Department
                                    </label>
                                    <select
                                        className="form-select form-select-sm"
                                        id="department"
                                        value={selectedDepartment}  // You'll need a state for this
                                        onChange={handleDepartmentChange}  // You'll need a handler for this
                                    >
                                        <option value="">Select Department</option>
                                        {Array.isArray(departments) &&
                                            [...departments]
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((dept) => (
                                                    <option key={dept.id} value={dept.name}>
                                                        {dept.name}
                                                    </option>
                                                ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="mb-2">
                                {/* Select Checker User Dropdown */}
                                <label htmlFor="checkerUser" className="form-label text-black mb-1">
                                    Checker
                                </label>
                                <select
                                    className="form-control form-control-sm"
                                    id="dropdown"
                                    value={selectedOption}
                                    onChange={handleSelectChange}
                                >
                                    <option value="">Select Checker</option>
                                    {users.map((user) => (
                                        <option key={user.id} value={user.id}>{user.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className={`col-md-4 col-sm-4 ${styles.supportedFileFormats}`}>
                            <div className="mb-2">
                                <h6 className="mb-1 mt-1 text-dark">Template List</h6>
                            </div>
                            <div className="mb-1">
                                <div className="row">
                                    {currentTemplates.map((template) => {
                                        const isAssigned = templateAssignments[template.name] === selectedOption;
                                        const isDisabled = selectedOption === "" || selectedOption === null;

                                        return (
                                            <div key={template.id} className="col-md-6">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`template-${template.id}`}
                                                        value={template.name}
                                                        onChange={() => handleCheckboxChange(template.name)}
                                                        disabled={isDisabled}
                                                        checked={isAssigned}
                                                    />
                                                    <label
                                                        className={`form-check-label ${styles.customCheckboxLabel}`}
                                                        htmlFor={`template-${template.id}`}
                                                        title={
                                                            isDisabled
                                                                ? "Please select a checker"
                                                                : template.name
                                                        }
                                                    >
                                                        {template.name}
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {templates.length > recordsPerPage && (
                                <PaginationComponentForm2
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    paginate={paginate}
                                />
                            )}
                        </div>

                        <div className={`col-md-5 col-sm-6`}>
                            <div className="mb-2">
                                <h6 className="mb-1 mt-1 text-dark">User Template Mapping</h6>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <div className='table-on-homepage-only d-flex justify-content-center'>
                                    {/* {tableData.length > 0 ? ( */}
                                    {isLoadingUserTable ? (
                                        <div className="text-center my-3">
                                            <span className="spinner-border spinner-border-sm text-primary" />
                                        </div>
                                    ) : tableData.length > 0 ? (
                                        <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                            <thead>
                                                <tr>
                                                    <th>Checker Id</th>
                                                    <th>Checker Name</th>
                                                    <th>Checked Templates</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderUserTable()}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <h6 className='h6-Font-Size mb-1-1'>Templates list with assigned Checkers</h6>
                                    )}

                                </div>
                            </div>
                            <div className="row">
                                <div className="col text-center">
                                    <div className="mb-2">
                                        <UsersPagination
                                            currentPage={userPage}
                                            itemsPerPage={userItemsPerPage}
                                            totalItems={tableData.length}
                                            onPageChange={setUserPage}
                                        />
                                    </div>
                                    {tableData.length > 0 && (
                                        <div className="d-flex justify-content-center gap-2">
                                            <button className="btn btn-sm btn-outline-primary me-2" onClick={handleReset}>Reset</button>
                                            <button className="btn btn-sm btn-primary" onClick={handleSave}>Save</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    show={successMsg || failureMsg || warningMsg}

                    backdrop="static"
                    keyboard={false}
                    style={{
                        marginTop: '12vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                    }}
                >
                    <div
                        className={`alert alert-${successMsg ? 'success' : failureMsg ? 'danger' : 'warning'} alert-dismissible fade show`}
                        role="alert"
                        style={{
                            margin: 0,
                            padding: '10px 14px',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            width: '100%',
                            fontSize: '14px', //  set base font size
                        }}
                    >
                        <span style={{ fontSize: '1rem' }}>
                            {successMsg ? '✅' : failureMsg ? '❌' : '⚠️'}
                        </span>
                        <div
                            style={{
                                flex: 1,
                                color: successMsg ? 'green' : failureMsg ? 'red' : 'orange',
                                fontSize: '14px', //  force message font size
                                wordBreak: 'break-word',
                            }}
                            dangerouslySetInnerHTML={{
                                __html: successMsg || failureMsg || warningMsg,
                            }}
                        />
                        <button
                            type="button"
                            aria-label="Close"
                            className="btn-close"


                            onClick={() => {
                                if (successMsg) {
                                    navigate('/gapsyAdashboard'); // ← change this to your target route
                                } else if (warningMsg) {
                                    handleSet();

                                } else {
                                    handleReset();
                                }
                            }}

                            style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                width: '10px',
                                height: '10px',
                                fontSize: '8px',
                                padding: '0',
                            }}
                        ></button>

                    </div>
                </Modal>
                <Modal
                    show={showConfirm}
                    onHide={handleCloseConfirm}
                    backdrop="static"
                    keyboard={false}
                    style={{ marginTop: '12vh', marginLeft: 'auto', marginRight: 'auto' }} // upper and slightly smaller
                >
                    <Modal.Header
                        style={{
                            backgroundColor: '#366872',
                            color: 'white',
                            padding: '0.5rem 1rem'
                        }}
                    >
                        <Modal.Title style={{ fontSize: '16px' }}>
                            Confirm Action
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                        <div dangerouslySetInnerHTML={{ __html: confirmMessage }} />
                    </Modal.Body>

                    <Modal.Footer style={{ borderTop: 'none', padding: '0.5rem 1rem' }}>
                        <Button
                            variant="secondary"
                            style={{ padding: '0.3rem 0.9rem', fontSize: '13px' }}
                            onClick={handleCloseConfirm}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            style={{ padding: '0.3rem 0.9rem', fontSize: '13px' }}
                            onClick={handleConfirmAction}
                        >
                            Yes, Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>


                {isLoading && (
                    <div className="loading-overlay">
                       
                        <LoadingIcon />
                    </div>
                )}
            </main>
            <Footer />
        </div>
    );
};

export default GapsySamplePage;
